// Storage: localStorage wrapper (web-only).
// Matches the API of the RN storage helper so ported code can use it as-is.
// Values are JSON-serialized so booleans/numbers round-trip.

class LocalStorage {
  _warn(op, key, e) {
    // eslint-disable-next-line no-console
    console.warn(`[storage] ${op}(${key}) failed`, e);
  }

  async getItem(key, fallback = null) {
    try {
      const raw = window.localStorage.getItem(key);
      if (raw === null) return fallback;
      try {
        return JSON.parse(raw);
      } catch {
        return fallback;
      }
    } catch (e) {
      this._warn("getItem", key, e);
      return fallback;
    }
  }

  async setItem(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      this._warn("setItem", key, e);
      return false;
    }
  }

  async removeItem(key) {
    try {
      window.localStorage.removeItem(key);
      return true;
    } catch (e) {
      this._warn("removeItem", key, e);
      return false;
    }
  }

  // No Keychain on web — secure* helpers reuse localStorage.
  secureGet(key, fallback = null) {
    return this.getItem(key, fallback);
  }
  secureSet(key, value) {
    return this.setItem(key, value);
  }
  secureRemove(key) {
    return this.removeItem(key);
  }
}

export const storage = new LocalStorage();
